module.exports = __webpack_public_path__ + "img/GPU-Chart.e093ff4e.png";